import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { SeismicCommunityDto, LgaDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-seismic-community',
  templateUrl: './seismic-community.component.html',
  styleUrls: ['./seismic-community.component.scss']
})
export class SeismicCommunityComponent implements OnInit {

  [x: string]: any;
  @Input() seismiccommunitys: SeismicCommunityDto[];
  @Input() lgas: LgaDto[];
  seismiccommunityForm: FormGroup;
  seismiccommunityFormArray: FormGroup;
  control = new FormControl();
  @Input() routeAnimationsElements: any;
  @Output() changeEmit = new EventEmitter<SeismicCommunityDto>();
  @Output() deleteEvent = new EventEmitter<any>();

  // SubscriberId = '5ca0c7a7ef1d2e5760762ebd';
  // selectedLga: any;
  
  filteredDelete: Array<any> = [];
  filteredSeismicCommunity: Array<any> = [];
  status: boolean;
  selectedLgaId: any;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

    ngOnInit() {
      this.createSeismicCommunityForm();
      console.log("Reaching Component")
    }

    createSeismicCommunityForm() {
      this.seismiccommunityFormArray = this.fb.group({ SeismicCommunitys: this.fb.array([]) });
      this.seismiccommunityForm = this.fb.group({
        CommunityName: ['', Validators.required],
        LgaId: this.selectedLgaId,
          id: null
      });
    }

    setSeismicCommunity() {
      const control = this.seismiccommunityFormArray.controls.SeismicCommunitys as FormArray;
      this.filteredSeismicCommunity.forEach((e) => {
        control.push(
          this.fb.group({
            CommunityName: e.CommunityName,
            LgaId: e.LgaId,
            id: e.id,
          })
        );
      });
    }
  
    //method to add lgas
    addSeismicCommunity(seismiccommunity: SeismicCommunityDto ){
      console.log('SeismicCommunity');
      const control = this.seismiccommunityFormArray.controls.SeismicCommunitys as FormArray;
      control.insert(
        0,
        this.fb.group({
          CommunityName: seismiccommunity.CommunityName,
          LgaId: this.selectedLgaId
        })
      );
    }
  
    // method to reset form array after selection
    clearFormArray = (formArray: FormArray) => {
      const control = this.seismiccommunityFormArray.controls.SeismicCommunitys as FormArray;
      while (formArray.length !== 0) {
        control.removeAt(0);
      }
    };
  
    // method to filter seismiccommunity
    selectLga(event: string) {
      this.filteredSeismicCommunity = this.seismiccommunitys.filter((s) => s.LgaId === event);
      console.log("name ", this.filteredSeismicCommunity, this.seismiccommunitys)
      this.selectedLgaId = event;
      const control = this.seismiccommunityFormArray.controls.SeismicCommunitys as FormArray;
  
      if (this.filteredSeismicCommunity.length > 0) {
        this.status = true;
        this.clearFormArray(control);
        this.setSeismicCommunity();
      } else {
        this.status = true;
        this.clearFormArray(control);
      }
    }
  
   
  
    print(event: any) {
      window.print();
    }
    // method to delete lga from arrary list
    deleteSeismicCommunity(index, value) {
      Swal.fire({
        title: 'Are you sure?',
        text: 'You will not be able to recover this imaginary file!',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No, keep it',
      }).then((result) => {
        if (result.value) {
          const control = this.seismiccommunityFormArray.controls.SeismicCommunitys as FormArray;
          control.removeAt(index);
          for (let i = 0; i < this.seismiccommunitys.length; i++) {
            if (i === index) {
              if (value.id !== null) {
                this.filteredDelete.push(this.seismiccommunitys[i].id);
              }
            }
          }
          Swal.fire(
            'Deleted!',
            'Your imaginary file has been deleted.',
            'success'
          );
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire('Cancelled', 'Your imaginary file is safe :)', 'error');
        }
      });
    }
    addNew(formValue: SeismicCommunityDto) {
      if(this.seismiccommunityForm.invalid) {
     return Swal.fire(
        'Warning!',
        'Please, you cannot add blank field',
        'warning'
      );
      }
      if(this.selectedIndex != null) {
  
        this.seismiccommunityFormArray.get('SeismicCommunitys')['controls'][this.selectedIndex].patchValue({CommunityName: formValue.CommunityName});
      } else {
        this.addSeismicCommunity(formValue);
      }
      this.selectedIndex = null;
      this.seismiccommunityForm.reset()
    }
  
    onEdit(index, value: SeismicCommunityDto) {
      this.selectedIndex = index;
      this.seismiccommunityForm.patchValue({CommunityName: value.CommunityName});
    }
  
    onClearForm() {
      this.selectedIndex = null;
      this.seismiccommunityForm.reset();
    }
  
    onSubmit(formValue: any) {
      formValue.type = 'seismiccommunity';
      this.changeEmit.emit(formValue);
      if (this.filteredDelete.length !== 0) {
        this.filteredDelete.unshift('seismiccommunity');
        this.deleteEvent.emit(this.filteredDelete);
      }
    }
  }
  